"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));
var _react = _interopRequireWildcard(require("react"));
var _sentry = require("../sentry");
var _ErrorMessage = _interopRequireDefault(require("./ErrorMessage"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var ErrorBoundary = /*#__PURE__*/function (_Component) {
  (0, _inheritsLoose2.default)(ErrorBoundary, _Component);
  function ErrorBoundary() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    _this.state = {
      error: null,
      info: null
    };
    return _this;
  }
  var _proto = ErrorBoundary.prototype;
  _proto.componentDidCatch = function componentDidCatch(error, info) {
    this.setState({
      error: error,
      info: info
    });
    (0, _sentry.captureException)(error, {
      extra: info
    });
  };
  _proto.render = function render() {
    if (this.state.error) {
      if (this.props.component) {
        return /*#__PURE__*/(0, _react.createElement)(this.props.component, Object.assign({}, this.props, this.state));
      }
      if (this.props.render) {
        return this.props.render(Object.assign({}, this.props, this.state));
      }
      return /*#__PURE__*/_react.default.createElement(_ErrorMessage.default, {
        name: this.props.name
      });
    }
    return this.props.children;
  };
  return ErrorBoundary;
}(_react.Component);
var _default = exports.default = ErrorBoundary;